var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHome = function SvgIconHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m26.813 9.947-12-9.333a1.34 1.34 0 0 0-1.64 0L1.187 9.947c-.32.253-.52.64-.52 1.053v14.667a4 4 0 0 0 1.173 2.827 4.02 4.02 0 0 0 2.827 1.173H10a1.34 1.34 0 0 0 1.333-1.333v-12h5.333v12A1.34 1.34 0 0 0 18 29.667h5.333a4 4 0 0 0 2.827-1.173 4.02 4.02 0 0 0 1.173-2.827V11c0-.413-.187-.8-.52-1.053zm-2.147 15.72c0 .36-.147.693-.387.947s-.587.387-.947.387h-4V15A1.34 1.34 0 0 0 18 13.667h-8A1.34 1.34 0 0 0 8.667 15v12h-4a1.38 1.38 0 0 1-.947-.387 1.32 1.32 0 0 1-.387-.947V11.653L14 3.36l10.667 8.293v14.013z"
  })));
};
export default SvgIconHome;